import { render, staticRenderFns } from "./Rule.vue?vue&type=template&id=75a108d4&scoped=true&"
import script from "./Rule.vue?vue&type=script&lang=js&"
export * from "./Rule.vue?vue&type=script&lang=js&"
import style0 from "./Rule.vue?vue&type=style&index=0&id=75a108d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a108d4",
  null
  
)

export default component.exports